import { APIService } from "../../../../network/api/APIService";

export const FileListData = async ({ ownerId , pageFilters}) => {

    let baseEndpoint = `/file/list/`;
    if (ownerId) {
        baseEndpoint += `?owner=${ownerId}`;
    } else {
        baseEndpoint += `?owner_id=0`;
    }

    const filtersQuery = Object.entries(pageFilters)
        .filter(([_, value]) => value !== null && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const endpoint = `${baseEndpoint}${filtersQuery ? `&${filtersQuery}` : ""}`;

    const config = {
        endpoint: endpoint,
        method: "GET",
    };

    return APIService(config);
};